/*
As Shopify Forms uses the shadow DOM when including the form it is necessary to
set any custom styles using JavaScript.
Also, the form is rendered using JS as well, so the timeout it to give it enough
time to render before applying styles (there might be a better way of doing this though)
 */



setTimeout(()=>{
    const appForm = document.getElementById('app-embed');

    const formContainer = appForm.shadowRoot.querySelector('section[data-testid="form-container"]');
    formContainer.style.maxWidth = "645px";

    const checkboxContainer = appForm.shadowRoot.querySelector('fieldset[name="custom#used_equipment_opt_in"] > div');
    checkboxContainer.style.gridTemplateColumns = "1fr 1fr";

    const emailForm = appForm.shadowRoot.querySelector('form[data-testid="form"]');
    emailForm.style.gap = "10px 0";

    const emailField = appForm.shadowRoot.querySelector('form[data-testid="form"] > div');



}, "1000");
